import { Mail, Phone, Send } from "lucide-react";
import React, { useRef } from "react";
import Loading from "./Loading";
import { toast } from "sonner";
import styles from "./Contato.module.css";

const Contato = () => {
  const form = useRef<HTMLFormElement>(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSendMessage = async (
    event: React.FormEvent<HTMLFormElement>,
  ) => {
    event.preventDefault();

    setIsLoading(true);

    try {
      if (!form.current) return;

      const formData = new FormData(form.current);

      const nome = formData.get("nome")?.toString() || "";
      const email = formData.get("email")?.toString() || "";
      const telefone = formData.get("telefone")?.toString() || "";
      const mensagem = formData.get("mensagem")?.toString() || "";

      const response = await fetch(
        `${process.env.REACT_APP_API}/api/chamado/contato`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            nome,
            email,
            telefone,
            mensagem,
          }),
        },
      );

      if (response.ok) {
        toast.success("Mensagem enviada com sucesso!");
        form.current.reset();
      } else {
        toast.error("Ocorreu um erro ao enviar a mensagem.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Ocorreu um erro ao enviar a mensagem.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.section} id="contato">
      <div className={styles.header} data-aos="fade-up">
        <span className={styles.eyebrow}>Fale com a gente</span>
        <h1 className={styles.title}>Contato</h1>
      </div>

      <div className={styles.grid}>
        <div className={styles.infoCard} data-aos="fade-right">
          <div>
            <h5 className={styles.infoHeading}>Canais diretos</h5>
            <p className={styles.infoSub}>
              Prefere falar agora? Nossa equipe responde por telefone ou
              e-mail nos horários comerciais.
            </p>

            <div className={styles.contactRow}>
              <span className={styles.iconChip}>
                <Phone size={17} />
              </span>
              <div className={styles.contactText}>
                <span className={styles.contactLabel}>Telefone</span>
                <span className={styles.contactValue}>(11) 98145-8600</span>
              </div>
            </div>

            <div className={styles.contactRow}>
              <span className={styles.iconChip}>
                <Phone size={17} />
              </span>
              <div className={styles.contactText}>
                <span className={styles.contactLabel}>Telefone</span>
                <span className={styles.contactValue}>(11) 96337-0510</span>
              </div>
            </div>

            <div className={styles.contactRow}>
              <span className={styles.iconChip}>
                <Mail size={17} />
              </span>
              <div className={styles.contactText}>
                <span className={styles.contactLabel}>E-mail</span>
                <span className={styles.contactValue}>
                  ikone@ikoneautomacao.com
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.formCard} data-aos="fade-left">
          <form
            className={styles.form}
            ref={form}
            onSubmit={handleSendMessage}
          >
            <div className={styles.fieldRow}>
              <div className={styles.field}>
                <label htmlFor="nome" className={styles.label}>
                  Nome <span className={styles.required}>*</span>
                </label>
                <input
                  id="nome"
                  type="text"
                  placeholder="Digite seu nome"
                  name="nome"
                  required
                  className={styles.input}
                />
              </div>

              <div className={styles.field}>
                <label htmlFor="telefone" className={styles.label}>
                  Telefone <span className={styles.required}>*</span>
                </label>
                <input
                  id="telefone"
                  type="tel"
                  placeholder="Digite seu telefone"
                  name="telefone"
                  required
                  className={styles.input}
                />
              </div>
            </div>

            <div className={styles.field}>
              <label htmlFor="email" className={styles.label}>
                Email <span className={styles.required}>*</span>
              </label>
              <input
                id="email"
                type="email"
                placeholder="Digite seu email"
                name="email"
                required
                className={styles.input}
              />
            </div>

            <div className={styles.field}>
              <label htmlFor="mensagem" className={styles.label}>
                Mensagem <span className={styles.required}>*</span>
              </label>
              <textarea
                id="mensagem"
                name="mensagem"
                placeholder="Digite sua mensagem"
                className={styles.textarea}
                rows={5}
                required
              ></textarea>
            </div>

            <button type="submit" className={styles.submitBtn} disabled={isLoading}>
              {isLoading ? (
                <Loading isButton={true} corPredefinida color="white" />
              ) : (
                <>
                  Enviar <Send size={16} />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contato;